export default __webpack_public_path__ + "static/media/nike_dunks_product_page.fee0b2ac.png";